import BaseTemplate from '../../components/baseTemplate';
import InfoInput from './InfoInput';
import Success from './Success';
import React, { useState } from 'react';
import './styles.scss';

const ForgotPassword: React.FC = () => {
    const [showSucess, setShowSuccess] = useState(false);
    const [email, setEmail] = useState('');
    return (
        <BaseTemplate>
            {showSucess ? (
                <Success email={email} />
            ) : (
                <InfoInput
                    setShowSuccess={setShowSuccess}
                    setEmail={setEmail}
                />
            )}
        </BaseTemplate>
    );
};

export default ForgotPassword;
